<script setup lang="ts">
import StyledModal from "@/components/_elements/modals/StyledModal.vue";
import { XMarkIcon } from "@heroicons/vue/20/solid";

const localKey = "clover.learn-announcement-modal";
const show = localStorage.getItem(localKey) !== "true";

const onClose = () => {
	localStorage.setItem(localKey, "true");
};

const redirect = (to) => {
	onClose();
	window.location.href = to;
};
</script>

<template>
	<StyledModal :start-open="show" @on-close="onClose">
		<template v-slot:panel="slotProps">
			<button
				class="fixed top-0 right-0"
				@click="slotProps.events?.closeModal()">
				<XMarkIcon
					class="rounded-full bg-white w-12 h-12 p-1 text-black"></XMarkIcon>
				<span class="sr-only">Close</span>
			</button>

			<img
				src="/img/learn-announcement-modal-image.jpg"
				class="w-full h-auto"
				alt="" />

			<div class="text-center text-pretty px-2 mt-6">
				<h2 class="mt-0">New Updates to Learn Reporting Beta!</h2>
				<p class="text-base text-gray-700">
					Experience a smoother design, CSV exports, additional
					filtering options, and enhanced data accuracy. Learn more
					about the
					<a
						class="text-blue-700 hover:no-underline hover:text-blue-700"
						href="https://help.cloverlearning.com/hc/en-us/articles/18218044277275-Learn-Reporting-Dashboard-Walkthrough-Admin"
						target="_blank"
						>latest updates</a
					>.<br />
				</p>

				<div class="flex mt-8 gap-2 items-center justify-center">
					<button
						@click="
							redirect('https://pulse.cloverlearning.com/learn')
						"
						class="hover:cursor-pointer button no-underline bg-blue-700 text-white rounded-md border-none hover:bg-blue-800 hover:text-white">
						Take Me to Learn Reporting
					</button>
				</div>
			</div>
		</template>
	</StyledModal>
</template>
